import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

import CustomFieldIntegerEditor from './CustomFieldIntegerEditor';
import CustomFieldBooleanEditor from './CustomFieldBooleanEditor';
import CustomFieldTextEditor from './CustomFieldTextEditor';

export const CUSTOM_FIELD_TYPES = {
  INTEGER: 'INTEGER',
  BOOLEAN: 'BOOLEAN',
  LOCALIZED_TEXT: 'LOCALIZED_TEXT',
};

const CustomFieldEditor = ({ name, type, value, setCurrentCustomFields }) => {
  const handleCustomFieldValueChange = (newValue) => {
    setCurrentCustomFields((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  switch (type) {
    case CUSTOM_FIELD_TYPES.INTEGER:
      return (
        <CustomFieldIntegerEditor
          value={value}
          handleCustomFieldValueChange={handleCustomFieldValueChange}
        />
      );
    case CUSTOM_FIELD_TYPES.BOOLEAN:
      return (
        <CustomFieldBooleanEditor
          value={value}
          handleCustomFieldValueChange={handleCustomFieldValueChange}
        />
      );
    case CUSTOM_FIELD_TYPES.LOCALIZED_TEXT:
      return (
        <CustomFieldTextEditor
          value={value}
          handleCustomFieldValueChange={handleCustomFieldValueChange}
        />
      );
    default:
      return <Typography>{JSON.stringify(value || '')}</Typography>;
  }
};

const { string, oneOfType, bool, object, func } = PropTypes;

CustomFieldEditor.propTypes = {
  name: string,
  type: string,
  value: oneOfType([string, bool, object]),
  setCurrentCustomFields: func,
};

export default CustomFieldEditor;
